var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppStoreQr = function SvgAppStoreQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1023 1023"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1023v1023H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310 62h31.93v31.93H310zM372 62h31.93v31.93H372zM434 62h31.93v31.93H434zM496 62h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 62h31.93v31.93H527zM589 62h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 62h31.93v31.93H620zM682 62h31.93v31.93H682zM310 93h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 93h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 93h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 93h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 93h31.93v31.93H434zM496 93h31.93v31.93H496zM558 93h31.93v31.93H558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 93h31.93v31.93H589zM651 93h31.93v31.93H651zM310 124h31.93v31.93H310zM434 124h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 124h31.93v31.93H558zM620 124h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 124h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 124h31.93v31.93H682zM372 155h31.93v31.93H372zM465 155h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 155h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 155h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 155h31.93v31.93H558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 155h31.93v31.93H589zM651 155h31.93v31.93H651zM372 186h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 186h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 186h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 186h31.93v31.93H465zM558 186h31.93v31.93H558zM620 186h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 186h31.93v31.93H651zM310 217h31.93v31.93H310zM372 217h31.93v31.93H372zM434 217h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 217h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 217h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 217h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 217h31.93v31.93H558zM620 217h31.93v31.93H620zM310 248h31.93v31.93H310zM372 248h31.93v31.93H372zM434 248h31.93v31.93H434zM496 248h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 248h31.93v31.93H558zM620 248h31.93v31.93H620zM682 248h31.93v31.93H682zM310 279h31.93v31.93H310zM403 279h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 279h31.93v31.93H434zM527 279h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 279h31.93v31.93H558zM651 279h31.93v31.93H651zM124 310h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 310h31.93v31.93H155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 310h31.93v31.93H186zM248 310h31.93v31.93H248zM310 310h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 310h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 310h31.93v31.93H372zM434 310h31.93v31.93H434zM527 310h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 310h31.93v31.93H558zM620 310h31.93v31.93H620zM713 310h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 310h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 310h31.93v31.93H775zM868 310h31.93v31.93H868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 310h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 310h31.93v31.93H930zM93 341h31.93v31.93H93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 341h31.93v31.93H124zM310 341h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 341h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 341h31.93v31.93H372zM434 341h31.93v31.93H434zM496 341h31.93v31.93H496zM589 341h31.93v31.93H589zM713 341h31.93v31.93H713zM775 341h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 341h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 341h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 341h31.93v31.93H868zM930 341h31.93v31.93H930zM93 372h31.93v31.93H93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 372h31.93v31.93H124zM186 372h31.93v31.93H186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 372h31.93v31.93H217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 372h31.93v31.93H248zM372 372h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 372h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 372h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 372h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 372h31.93v31.93H496zM558 372h31.93v31.93H558zM682 372h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 372h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 372h31.93v31.93H744zM806 372h31.93v31.93H806zM868 372h31.93v31.93H868zM124 403h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 403h31.93v31.93H155zM279 403h31.93v31.93H279zM341 403h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 403h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 403h31.93v31.93H403zM527 403h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 403h31.93v31.93H558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 403h31.93v31.93H589zM651 403h31.93v31.93H651zM713 403h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 403h31.93v31.93H744zM837 403h31.93v31.93H837zM899 403h31.93v31.93H899zM93 434h31.93v31.93H93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 434h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 434h31.93v31.93H155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 434h31.93v31.93H186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 434h31.93v31.93H217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 434h31.93v31.93H248zM310 434h31.93v31.93H310zM403 434h31.93v31.93H403zM465 434h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 434h31.93v31.93H496zM558 434h31.93v31.93H558zM682 434h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 434h31.93v31.93H713zM775 434h31.93v31.93H775zM868 434h31.93v31.93H868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 434h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 434h31.93v31.93H930zM62 465h31.93v31.93H62zM124 465h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 465h31.93v31.93H155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 465h31.93v31.93H186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 465h31.93v31.93H217zM279 465h31.93v31.93H279zM341 465h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 465h31.93v31.93H372zM434 465h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 465h31.93v31.93H465zM527 465h31.93v31.93H527zM589 465h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 465h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 465h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 465h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 465h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 465h31.93v31.93H744zM806 465h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 465h31.93v31.93H837zM899 465h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 465h31.93v31.93H930zM93 496h31.93v31.93H93zM186 496h31.93v31.93H186zM248 496h31.93v31.93H248zM310 496h31.93v31.93H310zM372 496h31.93v31.93H372zM434 496h31.93v31.93H434zM589 496h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 496h31.93v31.93H620zM682 496h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 496h31.93v31.93H713zM775 496h31.93v31.93H775zM93 527h31.93v31.93H93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 527h31.93v31.93H124zM279 527h31.93v31.93H279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 527h31.93v31.93H310zM434 527h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 527h31.93v31.93H465zM527 527h31.93v31.93H527zM589 527h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 527h31.93v31.93H620zM806 527h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 527h31.93v31.93H837zM93 558h31.93v31.93H93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 558h31.93v31.93H124zM248 558h31.93v31.93H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 558h31.93v31.93H279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 558h31.93v31.93H310zM372 558h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 558h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 558h31.93v31.93H434zM589 558h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 558h31.93v31.93H620zM713 558h31.93v31.93H713zM775 558h31.93v31.93H775zM837 558h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 558h31.93v31.93H868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 558h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 558h31.93v31.93H930zM62 589h31.93v31.93H62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 589h31.93v31.93H93zM155 589h31.93v31.93H155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 589h31.93v31.93H186zM372 589h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 589h31.93v31.93H403zM496 589h31.93v31.93H496zM682 589h31.93v31.93H682zM744 589h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 589h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 589h31.93v31.93H806zM868 589h31.93v31.93H868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 589h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 589h31.93v31.93H930zM62 620h31.93v31.93H62zM186 620h31.93v31.93H186z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 620h31.93v31.93H217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 620h31.93v31.93H248zM310 620h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 620h31.93v31.93H341zM403 620h31.93v31.93H403zM465 620h31.93v31.93H465zM527 620h31.93v31.93H527zM620 620h31.93v31.93H620zM744 620h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 620h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 620h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 620h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 620h31.93v31.93H868zM62 651h31.93v31.93H62zM124 651h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 651h31.93v31.93H155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186 651h31.93v31.93H186zM310 651h31.93v31.93H310zM372 651h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 651h31.93v31.93H403zM465 651h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 651h31.93v31.93H496zM651 651h31.93v31.93H651zM744 651h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 651h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 651h31.93v31.93H806zM899 651h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 651h31.93v31.93H930zM62 682h31.93v31.93H62zM124 682h31.93v31.93H124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 682h31.93v31.93H155zM217 682h31.93v31.93H217z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 682h31.93v31.93H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279 682h31.93v31.93H279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 682h31.93v31.93H310zM434 682h31.93v31.93H434zM496 682h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 682h31.93v31.93H527z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 682h31.93v31.93H558zM682 682h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 682h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 682h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 682h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 682h31.93v31.93H806zM868 682h31.93v31.93H868zM310 713h31.93v31.93H310zM372 713h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 713h31.93v31.93H403z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 713h31.93v31.93H434z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 713h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 713h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 713h31.93v31.93H527zM620 713h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 713h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 713h31.93v31.93H682zM806 713h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 713h31.93v31.93H837zM899 713h31.93v31.93H899z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930 713h31.93v31.93H930zM372 744h31.93v31.93H372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 744h31.93v31.93H403zM465 744h31.93v31.93H465zM527 744h31.93v31.93H527zM651 744h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 744h31.93v31.93H682zM744 744h31.93v31.93H744zM806 744h31.93v31.93H806zM372 775h31.93v31.93H372zM465 775h31.93v31.93H465zM527 775h31.93v31.93H527zM589 775h31.93v31.93H589z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620 775h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 775h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 775h31.93v31.93H682zM806 775h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 775h31.93v31.93H837zM899 775h31.93v31.93H899zM310 806h31.93v31.93H310zM434 806h31.93v31.93H434zM527 806h31.93v31.93H527zM589 806h31.93v31.93H589zM682 806h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 806h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 806h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 806h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 806h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 806h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 806h31.93v31.93H868zM930 806h31.93v31.93H930zM310 837h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 837h31.93v31.93H341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 837h31.93v31.93H372zM434 837h31.93v31.93H434zM651 837h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 837h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 837h31.93v31.93H713zM775 837h31.93v31.93H775zM837 837h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 837h31.93v31.93H868zM310 868h31.93v31.93H310z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 868h31.93v31.93H341zM434 868h31.93v31.93H434zM496 868h31.93v31.93H496zM620 868h31.93v31.93H620z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 868h31.93v31.93H651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682 868h31.93v31.93H682z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713 868h31.93v31.93H713z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 868h31.93v31.93H744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775 868h31.93v31.93H775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806 868h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 868h31.93v31.93H837z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868 868h31.93v31.93H868z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899 868h31.93v31.93H899zM372 899h31.93v31.93H372zM465 899h31.93v31.93H465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 899h31.93v31.93H496z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 899h31.93v31.93H527zM806 899h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 899h31.93v31.93H837zM899 899h31.93v31.93H899zM372 930h31.93v31.93H372zM558 930h31.93v31.93H558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 930h31.93v31.93H589zM651 930h31.93v31.93H651zM744 930h31.93v31.93H744zM806 930h31.93v31.93H806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837 930h31.93v31.93H837z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.75 279h79.05c37.2 0 68.2-31 68.2-68.2v-79.05C279 93 248 62 209.25 62H130.2C93 62 62 93 62 130.2v79.05C62 248 93 279 131.75 279M248 136.4v68.2c0 23.25-20.15 43.4-43.4 43.4h-68.2c-24.8 0-43.4-18.6-43.4-43.4v-68.2c0-23.25 20.15-43.4 43.4-43.4h68.2c24.8 0 43.4 18.6 43.4 43.4M813.75 279h79.05c37.2 0 68.2-31 68.2-68.2v-79.05C961 93 930 62 891.25 62H812.2C775 62 744 93 744 130.2v79.05C744 248 775 279 813.75 279M930 136.4v68.2c0 23.25-20.15 43.4-43.4 43.4h-68.2c-24.8 0-43.4-18.6-43.4-43.4v-68.2c0-23.25 20.15-43.4 43.4-43.4h68.2c24.8 0 43.4 18.6 43.4 43.4M131.75 961h79.05c37.2 0 68.2-31 68.2-68.2v-79.05C279 775 248 744 209.25 744H130.2C93 744 62 775 62 812.2v79.05C62 930 93 961 131.75 961M248 818.4v68.2c0 23.25-20.15 43.4-43.4 43.4h-68.2c-24.8 0-43.4-18.6-43.4-43.4v-68.2c0-23.25 20.15-43.4 43.4-43.4h68.2c24.8 0 43.4 18.6 43.4 43.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 150.35v41.85c0 12.4-12.4 24.8-26.35 24.8h-40.3c-15.5 0-26.35-10.85-26.35-26.35v-40.3c0-13.95 12.4-26.35 26.35-26.35h41.85c13.95 0 24.8 10.85 24.8 26.35M899 150.35v41.85c0 12.4-12.4 24.8-26.35 24.8h-40.3c-15.5 0-26.35-10.85-26.35-26.35v-40.3c0-13.95 12.4-26.35 26.35-26.35h41.85c13.95 0 24.8 10.85 24.8 26.35M217 832.35v41.85c0 12.4-12.4 24.8-26.35 24.8h-40.3c-15.5 0-26.35-10.85-26.35-26.35v-40.3c0-13.95 12.4-26.35 26.35-26.35h41.85c13.95 0 24.8 10.85 24.8 26.35"
  }))));
};
export default SvgAppStoreQr;